
import Vue from 'vue'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import PageLayout from '@/layouts/Page.vue'
import PageMenuLayout from '@/layouts/PageMenu.vue'
import ProspectForm from '@/components/forms/ProspectForm.vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'

const prospectModule = namespace('prospect')

@Component({
  components: {
    PageLayout,
    PageMenuLayout,
    BaseFormContainer,
    ProspectForm
  }
})
export default class ProspectCreate extends Vue {
  @prospectModule.Action('createProspectAction') createProspect: any

  onSubmit(data: any) {
    this.createProspect(data).then(async (data: any) => {
      this.$router.push({name: 'prospectDetail', params: {id: data.ID}})
    })
  }

  onCancel() {
    this.$router.go(-1)
  }
}
